module.exports = __webpack_public_path__ + "img/抖音.3d45881e.png";